import { IExperienceDetails } from 'types/IExperienceDetails';

const EXPERIENCE_DETAILS: IExperienceDetails = {
  'e-butler': {
    title: 'EButler',
    items: [
      {
        levelOneText: 'Position: Frontend Engineer',
      },
      {
        levelOneText: 'Duration: 2 Years',
      },
      {
        levelOneText: 'Key Technologies:',
        levelTwoTexts: [
          'Frameworks/Libraries: React, TypeScript, Chakra UI',
          'Version Control: GitHub',
          'Project Architecture: Microfrontends using Webpack’s Module Federation',
        ],
      },
      {
        levelOneText: 'Project',
        levelTwoTexts: [
          'Enable is a B2B SaaS platform serving the F&B industry, with clients across Qatar, UAE, Egypt, and more. I was part of the Loyalty Squad, responsible for building a comprehensive loyalty program from the ground up.',
        ],
      },
      {
        levelOneText: 'Loyalty Program Features:',
        levelTwoTexts: ['Coupons, Tiers, Punch Cards, and Challenges.'],
      },
      {
        levelOneText: 'Loyalty Registration Page:',
        levelTwoTexts: [
          'Designed and developed a fully responsive Loyalty Registration Page used by thousands of users daily, optimized for both mobile and desktop platforms.',
          'Iterated through 4 UX versions, achieving a seamless user experience that resulted in an 85%+ conversion rate, as tracked by analytics tools like Amplitude, Smartlook, and Mixpanel.',
        ],
      },
      {
        levelOneText: 'More activities:',
        levelTwoTexts: [
          'Led code reviews (PRs), ensured code documentation, and performed integration checks with backend services.',
          'Reviewed Data Contracts (DCs) with the backend team to ensure accurate communication and alignment between frontend and backend systems.',
          'Collaborated in an Agile environment, contributing to sprint planning, task estimation, and feature development.',
        ],
      },
    ],
  },

  'hassan-allam-holding': {
    title: 'Hassan Allam Holding',
    items: [
      {
        levelOneText: 'string',
        levelTwoTexts: ['string'],
      },
    ],
  },
  'orascom-construction-plc': {
    title: 'Orascom Construction PLC',
    items: [
      {
        levelOneText: 'string',
        levelTwoTexts: ['string'],
      },
    ],
  },
  '4s-technology': {
    title: '4S Technology',
    items: [
      {
        levelOneText: 'string',
        levelTwoTexts: ['string'],
      },
    ],
  },
};

export default EXPERIENCE_DETAILS;
